@if (modalAction) {
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" [innerHTML]="modalAction.header | safe: 'html'"></h5>
    </div>
    <div class="modal-body">
      <form id="ngForm" #ngForm="ngForm">
        @for (element of modalAction.content; track $index) {
          <ng-container *ngComponentOutlet="element.componentType; inputs: { element: element }"></ng-container>
        }
      </form>
    </div>
    <div class="modal-footer">
      @for (option of modalAction.modalOptions; track $index) {
        <button type="button" class="btn btn-default"
          [ngClass]="option?.layout?.class | class" [ngStyle]="option?.layout?.style | style"
        (click)="action($event, option)" [innerHTML]="option.text| safe: 'html'"></button>
      }
    </div>
  </div>
}
